import { render } from "./CommentDetail.vue?vue&type=template&id=3f92a13e"
import script from "./CommentDetail.vue?vue&type=script&lang=js"
export * from "./CommentDetail.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__